/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { MapPin } from '../models/map-pin';
import { MapLayerType } from '../models/map-layer-type';
import { MapLayerItem } from '../models/map-layer-item';
@Injectable({
  providedIn: 'root',
})
class MapService extends __BaseService {
  static readonly MapGetMapPinsPath = '/api/Map/GetMapPins/{customerId}';
  static readonly MapGetMapPinsPublicPath = '/api/Map/GetMapPinsPublic';
  static readonly MapGetMapLayerTypesPath = '/api/Map/MapLayerTypes/{customerId}';
  static readonly MapGetMapLayerTreePath = '/api/Map/MapLayerTree/{customerId}';
  static readonly MapGetMapLayersPath = '/api/Map/MapLayers/{customerId}';
  static readonly MapAddMapLayerPath = '/api/Map/AddMapLayer';
  static readonly MapUpdateMapLayerPath = '/api/Map/UpdateMapLayer';
  static readonly MapDeleteMapLayerPath = '/api/Map/DeleteMapLayer';
  static readonly MapProxyByLayerIdPath = '/api/Map/Proxy/{layerId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  MapGetMapPinsResponse(customerId: number): __Observable<__StrictHttpResponse<Array<MapPin>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/GetMapPins/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MapPin>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  MapGetMapPins(customerId: number): __Observable<Array<MapPin>> {
    return this.MapGetMapPinsResponse(customerId).pipe(
      __map(_r => _r.body as Array<MapPin>)
    );
  }
  MapGetMapPinsPublicResponse(): __Observable<__StrictHttpResponse<Array<MapPin>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/GetMapPinsPublic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MapPin>>;
      })
    );
  }  MapGetMapPinsPublic(): __Observable<Array<MapPin>> {
    return this.MapGetMapPinsPublicResponse().pipe(
      __map(_r => _r.body as Array<MapPin>)
    );
  }

  /**
   * @param customerId undefined
   */
  MapGetMapLayerTypesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<MapLayerType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/MapLayerTypes/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MapLayerType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  MapGetMapLayerTypes(customerId: number): __Observable<Array<MapLayerType>> {
    return this.MapGetMapLayerTypesResponse(customerId).pipe(
      __map(_r => _r.body as Array<MapLayerType>)
    );
  }

  /**
   * @param customerId undefined
   */
  MapGetMapLayerTreeResponse(customerId: number): __Observable<__StrictHttpResponse<MapLayerItem>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/MapLayerTree/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MapLayerItem>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  MapGetMapLayerTree(customerId: number): __Observable<MapLayerItem> {
    return this.MapGetMapLayerTreeResponse(customerId).pipe(
      __map(_r => _r.body as MapLayerItem)
    );
  }

  /**
   * @param customerId undefined
   */
  MapGetMapLayersResponse(customerId: number): __Observable<__StrictHttpResponse<Array<MapLayerItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/MapLayers/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MapLayerItem>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  MapGetMapLayers(customerId: number): __Observable<Array<MapLayerItem>> {
    return this.MapGetMapLayersResponse(customerId).pipe(
      __map(_r => _r.body as Array<MapLayerItem>)
    );
  }

  /**
   * @param model undefined
   */
  MapAddMapLayerResponse(model: MapLayerItem): __Observable<__StrictHttpResponse<MapLayerItem>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Map/AddMapLayer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MapLayerItem>;
      })
    );
  }
  /**
   * @param model undefined
   */
  MapAddMapLayer(model: MapLayerItem): __Observable<MapLayerItem> {
    return this.MapAddMapLayerResponse(model).pipe(
      __map(_r => _r.body as MapLayerItem)
    );
  }

  /**
   * @param model undefined
   */
  MapUpdateMapLayerResponse(model: MapLayerItem): __Observable<__StrictHttpResponse<MapLayerItem>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Map/UpdateMapLayer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MapLayerItem>;
      })
    );
  }
  /**
   * @param model undefined
   */
  MapUpdateMapLayer(model: MapLayerItem): __Observable<MapLayerItem> {
    return this.MapUpdateMapLayerResponse(model).pipe(
      __map(_r => _r.body as MapLayerItem)
    );
  }

  /**
   * @param model undefined
   */
  MapDeleteMapLayerResponse(model: MapLayerItem): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Map/DeleteMapLayer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param model undefined
   */
  MapDeleteMapLayer(model: MapLayerItem): __Observable<Blob> {
    return this.MapDeleteMapLayerResponse(model).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param layerId undefined
   */
  MapProxyByLayerIdResponse(layerId: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Map/Proxy/${encodeURIComponent(String(layerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param layerId undefined
   */
  MapProxyByLayerId(layerId: number): __Observable<Blob> {
    return this.MapProxyByLayerIdResponse(layerId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module MapService {
}

export { MapService }
